import React from "react";
import ContentPage from "../components/content-page";
import SEO from "../components/seo";
var AGBPage = function AGBPage(_ref) {
    var data = _ref.data;
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(SEO, {
        title: data.datoCmsAgb.title
    }), /*#__PURE__*/ React.createElement(ContentPage, {
        title: data.datoCmsAgb.title,
        content: data.datoCmsAgb.content
    }));
};
var query = "667802454";
export default AGBPage;
